<template>
    <div class="side-bar">
        <a-menu
                mode="inline"
                theme="dark"
                :openKeys="openKeys"
                @openChange="onOpenChange"
                @click="handleClick"
                :selectedKeys="selectedKey"
                :defaultSelectedKeys="selectedKey"
        >
            <a-menu-item key="home">
                <a-icon type="pie-chart" />
                <span>首頁</span>
            </a-menu-item>
            <a-sub-menu key="sub1">
                <span slot="title"><a-icon type="form" /><span>典籍管理</span></span>
                <a-menu-item key="lectionCla">典籍分類管理</a-menu-item>
                <a-menu-item key="lectionList">典籍列表</a-menu-item>
                <a-menu-item key="addLection">添加典籍</a-menu-item>
            </a-sub-menu>
            <a-sub-menu key="sub2">
                <span slot="title"><a-icon type="form" /><span>叢書管理</span></span>
                <a-menu-item key="wordCla">叢書分類管理</a-menu-item>
                <a-menu-item key="wordList">叢書列表</a-menu-item>
                <a-menu-item key="addWord">添加叢書</a-menu-item>
            </a-sub-menu>
            <a-sub-menu key="sub8">
                <span slot="title"><a-icon type="form" /><span>商品管理</span></span>
                <a-menu-item key="categoryManager">商品分類管理</a-menu-item>
                <a-menu-item key="proEdit">商品編輯</a-menu-item>
                <a-menu-item key="proList">已上架商品</a-menu-item>
                <a-menu-item key="proDownList">已下架商品</a-menu-item>
                <a-menu-item key="recommendPro">推薦商品</a-menu-item>
                <a-menu-item key="feightManager">郵費設置</a-menu-item>
            </a-sub-menu>
            <a-sub-menu key="sub9">
                <span slot="title"><a-icon type="form" /><span>訂單管理</span></span>
                <a-menu-item key="orderList">已付款訂單</a-menu-item>
                <a-menu-item key="sendOrder">已發貨訂單</a-menu-item>
                <a-menu-item key="noPayList">未付款訂單</a-menu-item>
                <a-menu-item key="cancelOrder">已取消訂單</a-menu-item>
            </a-sub-menu>
            <a-sub-menu key="sub3">
                <span slot="title"><a-icon type="form" /><span>音樂管理</span></span>
                <a-menu-item key="musicList">音樂列表</a-menu-item>
            </a-sub-menu>
            <a-sub-menu key="sub4">
                <span slot="title"><a-icon type="form" /><span>會員管理</span></span>
                <a-menu-item key="userList">賬號列表</a-menu-item>
                <a-menu-item key="vipManager">會員類型管理</a-menu-item>
            </a-sub-menu>
            <a-sub-menu key="sub5">
                <span slot="title"><a-icon type="form" /><span>公告管理</span></span>
                <a-menu-item key="noticeManager">公告設置</a-menu-item>
            </a-sub-menu>
            <a-sub-menu key="sub6">
                <span slot="title"><a-icon type="form" /><span>廣告管理</span></span>
                <a-menu-item key="bannerManager">PC廣告設置</a-menu-item>
                <a-menu-item key="mobileBannerManager">APP廣告設置</a-menu-item>
                <a-menu-item key="openOrClose">导航按钮隐藏</a-menu-item>
            </a-sub-menu>
            <a-sub-menu key="sub7">
                <span slot="title"><a-icon type="form" /><span>友情链接管理</span></span>
                <a-menu-item key="linkManager">友情链接管理</a-menu-item>
            </a-sub-menu>
        </a-menu>
</div>
</template>
<script>
    export default {
        data() {
            return {
                rootSubmenuKeys: ['sub1', 'sub2', 'sub3','sub4','sub5','sub6','sub7','sub8','sub9'],
                openKeys: [],
                selectedKey:[]
            }
        },
        methods: {
            handleClick(item){
                let self=this;
                if(item.key!==this.$route.name){
                    sessionStorage.setItem('actionMenu',JSON.stringify(item.keyPath))
                    this.$router.push({path:'/'+item.key})
                    this.selectedKey=[...item.keyPath]
                }

            },
            onOpenChange (openKeys) {
                const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1)
                if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
                    this.openKeys = openKeys
                } else {
                    this.openKeys = latestOpenKey ? [latestOpenKey] : []
                }
            },
        },
        created() {
            let self=this;
            if(sessionStorage.getItem('actionMenu')){
                self.$set(self,'selectedKey',JSON.parse(sessionStorage.getItem('actionMenu')))
                if(JSON.parse(sessionStorage.getItem('actionMenu')).length>1){
                    this.openKeys=[JSON.parse(sessionStorage.getItem('actionMenu'))[1]]
                }else{
                    this.openKeys=[JSON.parse(sessionStorage.getItem('actionMenu'))[0]]
                }
            }else{
                if(self.$route.path==='/'){
                    self.$set(self,'selectedKey',['home'])
                }else {
                    self.$set(self,'selectedKey',[self.$route.name])
                }
            }
        },
        watch:{
            '$route':function () {
                let self=this;
                if(self.$route.path==='/'){
                    self.$set(self,'selectedKey',['home'])
                }else {
                    self.$set(self,'selectedKey',[self.$route.name])
                }
            }
        }
    }
</script>
<style lang="less">
    div.side-bar{
        z-index: 2;
        .ant-menu-dark.ant-menu-inline .ant-menu-item, .ant-menu-dark.ant-menu-inline .ant-menu-submenu-title{
            text-align: left;
        }
        .ant-menu.ant-menu-dark .ant-menu-item-selected, .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected{
            text-align: left;
        }
        .ant-menu-dark, .ant-menu-dark .ant-menu-sub{
            background-color: #2c3049;
        }
        .ant-menu.ant-menu-dark .ant-menu-item-selected, .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected{
            background-color: #2c3e50;
        }
    }
</style>